// Importiere Bilder aus dem gallery Ordner
import bowImg from '../../imgs/gallery/bow.png'
import roofImg from '../../imgs/gallery/roof.png'
import darkspayImg from '../../imgs/gallery/darkspay.png'
import dragonImg from '../../imgs/gallery/dragon.jpg'
import gunImg from '../../imgs/gallery/gun.png'
import hugoImg from '../../imgs/gallery/hugo.jpg'
import carriageImg from '../../imgs/gallery/carriage.jpg'
import oldCarImg from '../../imgs/gallery/oldCar.jpg'
import pipeDarkspayImg from '../../imgs/gallery/pipe-darkspay.jpg'
import pipeSandboxerImg from '../../imgs/gallery/pipe-sandboxer.png'
import plapImg from '../../imgs/gallery/plap.png'
import circuitBoardImg from '../../imgs/gallery/circuit-board.jpg'
import robotImg from '../../imgs/gallery/robot.jpg'
import shotgunImg from '../../imgs/gallery/shotgun.png'
import speedArtImg from '../../imgs/gallery/speedArt.jpg'
import studioImg from '../../imgs/gallery/studio.jpg'
import swordImg from '../../imgs/gallery/sword.png'
import toolBoxImg from '../../imgs/gallery/toolBox.png'
import tunnelImg from '../../imgs/gallery/tunnel.png'
import submarineImg from '../../imgs/gallery/submarine.png'
import unrealImg from '../../imgs/gallery/unreal.jpg'
import cubeImg from '../../imgs/gallery/cube.jpg'
import bitaxeMonitorImg from '../../imgs/gallery/bitaxeMonitor.jpg'
import bitaxeTowerImg from '../../imgs/gallery/bitaxeTower.jpg'
import universeImg from '../../imgs/gallery/universe.jpg'
import scroggNetImg from '../../imgs/gallery/scroggNet.jpg'
import { thumbnails } from './thumbnails'

export type GalleryItem = {
  id: number
  type: 'image' | 'video'
  src: string
  thumbnail?: string
  title?: string
  category?: string
  description?: string
}

export const galleryItems: GalleryItem[] = [
  {
    id: 1,
    type: 'image',
    src: bitaxeMonitorImg,
    thumbnail: thumbnails.bitaxeMonitor,
    category: 'Software',
    title: 'Bitaxe Monitor'
  },
  {
    id: 2,
    type: 'image',
    src: bitaxeTowerImg,
    thumbnail: thumbnails.bitaxeTower,
    category: 'Construction',
    title: 'Bitaxe Tower'
  },
  {
    id: 3,
    type: 'image',
    src: universeImg,
    thumbnail: thumbnails.universe,
    category: 'Software',
    title: 'Universe'
  },
  {
    id: 4,
    type: 'image',
    src: bowImg,
    thumbnail: thumbnails.bow,
    category: '3D',
    title: 'Bow'
  },
  {
    id: 5,
    type: 'image',
    src: roofImg,
    thumbnail: thumbnails.roof,
    category: '3D',
    title: 'Roof'
  },
  {
    id: 6,
    type: 'image',
    src: darkspayImg,
    thumbnail: thumbnails.darkspay,
    category: '3D',
    title: 'Darkspay'
  },
  {
    id: 7,
    type: 'image',
    src: gunImg,
    thumbnail: thumbnails.gun,
    category: '3D',
    title: 'Gun'
  },
  {
    id: 8,
    type: 'image',
    src: pipeDarkspayImg,
    thumbnail: thumbnails['pipe-darkspay'],
    category: '3D',
    title: 'Pipe Darkspay'
  },
  {
    id: 9,
    type: 'image',
    src: pipeSandboxerImg,
    thumbnail: thumbnails['pipe-sandboxer'],
    category: '3D',
    title: 'Pipe Sandboxer'
  },
  {
    id: 10,
    type: 'image',
    src: shotgunImg,
    thumbnail: thumbnails.shotgun,
    category: '3D',
    title: 'Shotgun'
  },
  {
    id: 11,
    type: 'image',
    src: swordImg,
    thumbnail: thumbnails.sword,
    category: '3D',
    title: 'Sword'
  },
  {
    id: 12,
    type: 'image',
    src: toolBoxImg,
    thumbnail: thumbnails.toolBox,
    category: '3D',
    title: 'Tool Box'
  },
  {
    id: 13,
    type: 'image',
    src: tunnelImg,
    thumbnail: thumbnails.tunnel,
    category: '3D',
    title: 'Tunnel'
  },
  {
    id: 14,
    type: 'image',
    src: submarineImg,
    thumbnail: thumbnails.submarine,
    category: '3D',
    title: 'Submarine'
  },
  {
    id: 15,
    type: 'image',
    src: dragonImg,
    thumbnail: thumbnails.dragon,
    category: '3D',
    title: 'Dragon'
  },
  {
    id: 16,
    type: 'image',
    src: hugoImg,
    thumbnail: thumbnails.hugo,
    category: 'Joke',
    title: 'Hugo'
  },
  {
    id: 17,
    type: 'image',
    src: circuitBoardImg,
    thumbnail: thumbnails['circuit-board'],
    category: 'Construction',
    title: 'Circuit Board'
  },
  {
    id: 18,
    type: 'image',
    src: robotImg,
    thumbnail: thumbnails.robot,
    category: '3D',
    title: 'Robot'
  },
  {
    id: 19,
    type: 'image',
    src: speedArtImg,
    thumbnail: thumbnails.speedArt,
    category: '3D',
    title: 'Speed Art'
  },
  {
    id: 20,
    type: 'image',
    src: studioImg,
    thumbnail: thumbnails.studio,
    category: '3D',
    title: 'Studio'
  },
  {
    id: 21,
    type: 'image',
    src: unrealImg,
    thumbnail: thumbnails.unreal,
    category: '3D',
    title: 'Unreal'
  },
  {
    id: 22,
    type: 'image',
    src: cubeImg,
    thumbnail: thumbnails.cube,
    category: '3D',
    title: 'Cube'
  },
  {
    id: 23,
    type: 'image',
    src: scroggNetImg,
    thumbnail: thumbnails.scroggNet,
    category: 'Construction',
    title: 'ScroggNet'
  },
  {
    id: 24,
    type: 'image',
    src: carriageImg,
    thumbnail: thumbnails.carriage,
    category: '3D',
    title: 'Carriage'
  },
  {
    id: 25,
    type: 'image',
    src: oldCarImg,
    thumbnail: thumbnails.oldCar,
    category: '3D',
    title: 'Old Car'
  },
  {
    id: 26,
    type: 'image',
    src: plapImg,
    thumbnail: thumbnails.plap,
    category: '3D',
    title: 'Plap'
  }
]
